/* eslint-disable react/prop-types */
import { Text, View } from "@react-pdf/renderer"
import { useContext } from "react"
import AuthContext from "../../../../../../../contexts/Auth"
import { styles } from "./styles"
import intl from "react-intl-universal"
import { fnFormatDate } from "../../../../../../../utils/date"
import { CONTROL_LEVELS } from "../../../../constants"
import { colors } from "../styles"

export const Table = ({ run, unitOfMeasure, analyteType }) => {
  const authContext = useContext(AuthContext)
  const cUserTimeZone = authContext?.oUser?.data?.user_ctimezone

  const [levelOne, levelTwo, levelThree] = run.eqpanltrun_launches.sort(
    (a, b) => a.eqpanltlaunch_elevel - b.eqpanltlaunch_elevel,
  )
  const status = run?.eqpanltrun_status?.toUpperCase()
  const statusTexts = {
    PENDING: intl.get("ciq.status_race.pending"),
    REJECTED: intl.get("ciq.status_race.disapproved"),
    APPROVED: intl.get("ciq.status_race.approved"),
  }

  const levelData = {
    1: levelOne,
    2: levelTwo,
    3: levelThree,
  }

  const aLaunchesObservations =
    run?.eqpanltrun_launches
      ?.filter((item) => item?.eqpanltlaunch_cobservation)
      ?.map((item) => ({
        level: item.eqpanltlaunch_elevel,
        observation: item.eqpanltlaunch_cobservation,
      })) || []

  const bIsQuantitativeAnalyte = analyteType === "Quantitativo"

  return (
    <View style={styles.table} wrap={false}>
      <View style={styles.tableRow}>
        <View style={styles.columnRun}>
          <View style={{ ...styles.runCardDataLabel, borderTopLeftRadius: 4 }}>
            <Text style={styles.tableCell}>
              {intl.get("ciqReport.pdf.run_table.run_number")}
            </Text>
          </View>
        </View>

        <View style={styles.columnRun}>
          <View style={styles.runCardDataLabel}>
            <Text style={styles.tableCell}>
              {intl.get("ciqReport.pdf.run_table.date")}
            </Text>
          </View>
        </View>

        {CONTROL_LEVELS.map(({ level }) => (
          <>
            <View style={styles.columnLevel} key={`ciq-report-level-${level}-label`}>
              <View
                style={{
                  ...styles.runCardDataLabel,
                  borderRight: bIsQuantitativeAnalyte
                    ? "none"
                    : `1px solid ${colors.gray[20]}`,
                  alignItems: "center",
                }}
              >
                <Text style={styles.cBachText}>
                  {levelData[level]?.eqpanltlaunch_cbatch || "-"}
                </Text>
                <Text style={styles.tableCell}>
                  {intl.get("ciqReport.pdf.run_table.level", { level })}
                </Text>
              </View>
            </View>
            {bIsQuantitativeAnalyte && (
              <View style={styles.columnWestigard}>
                <View style={{ ...styles.runCardDataLabel, alignItems: "center" }}>
                  <Text style={styles.cBachText}> </Text> {/* placeholder */}
                  <Text style={styles.tableCell}>
                    {intl.get("ciqReport.pdf.run_table.westgard_rules")}
                  </Text>
                </View>
              </View>
            )}
          </>
        ))}

        <View style={styles.columnStatus}>
          <View style={{ ...styles.runCardDataLabel, borderTopRightRadius: 4 }}>
            <Text style={styles.tableCell}>Status</Text>
          </View>
        </View>
      </View>

      <View style={styles.tableRow}>
        <View style={styles.columnRun}>
          <View style={styles.runCardDataValue}>
            <Text style={{ ...styles.tableCellInfo, ...styles.runNumber }}>
              {run?.eqpanltrun_number}
            </Text>
          </View>
        </View>

        <View style={styles.columnRun}>
          <View style={styles.runCardDataValue}>
            <Text style={styles.tableCellInfo}>
              {fnFormatDate(
                run?.eqpanltrun_dcreated,
                "DD/MM/YY",
                true,
                cUserTimeZone,
                "YYYY-MM-DD HH:mm:ss",
              )}
            </Text>
            <Text style={styles.tableCellInfoItalic}>
              {fnFormatDate(
                run?.eqpanltrun_dcreated,
                "HH:mm:ss",
                true,
                cUserTimeZone,
                "YYYY-MM-DD HH:mm:ss",
              )}
            </Text>
          </View>
        </View>

        {CONTROL_LEVELS.map(({ level }) => (
          <>
            <View style={styles.columnLevel} key={`ciq-report-level-${level}-value`}>
              <View
                style={{
                  ...styles.launchValue,
                  borderRight: bIsQuantitativeAnalyte
                    ? "none"
                    : `1px solid ${colors.gray[20]}`,
                }}
              >
                <Text style={styles.tableCellInfo}>
                  {bIsQuantitativeAnalyte ? (
                    <RcmpRunLaunchValue
                      level={levelData[level]}
                      unitOfMeasure={unitOfMeasure}
                    />
                  ) : (
                    <>{levelData?.[level]?.eqpanltlaunch_resultopt_cdescription || "-"}</>
                  )}
                </Text>
              </View>
              {bIsQuantitativeAnalyte && (
                <View style={styles.tableCellVerticalLine}></View>
              )}
            </View>
            {bIsQuantitativeAnalyte && (
              <View style={styles.columnWestigard}>
                <RcmpLaunchWestgardRules
                  rules={levelData[level]?.eqpanltlaunch_awestgard_rules}
                />
              </View>
            )}
          </>
        ))}

        <View style={styles.columnStatus}>
          <View style={styles.runCardDataValue}>
            <Text style={styles.tableCellInfo}>{status ? statusTexts[status] : "-"}</Text>
          </View>
        </View>
      </View>

      {aLaunchesObservations?.length > 0 && (
        <View style={styles.tableRow}>
          {aLaunchesObservations.map(({ level, observation }) => (
            <View
              style={styles.columnObservation}
              key={`ciq-report-level-${level}-observation`}
            >
              <View style={styles.containerObservation}>
                <Text style={styles.tableCell}>
                  {intl.get("ciqReport.pdf.run_table.level_observation", { level })}
                </Text>
                <Text style={styles.observation}>{observation || "-"}</Text>
              </View>
            </View>
          ))}
        </View>
      )}

      <View style={styles.tableRow}>
        <View style={styles.columnObservation}>
          <View style={{ ...styles.containerObservation, borderBottomLeftRadius: 4 }}>
            <Text style={styles.tableCell}>
              {intl.get("ciqReport.pdf.run_table.cause")}
            </Text>
            <Text style={styles.observation}>
              {run?.eqpanltrun_causes?.length
                ? run.eqpanltrun_causes
                    .map((cause) => cause?.cause_cdescription)
                    ?.join(", ")
                : "-"}
            </Text>
          </View>
        </View>
        <View style={styles.columnObservation}>
          <View style={styles.containerObservation}>
            <Text style={styles.tableCell}>
              {intl.get("ciqReport.pdf.run_table.action")}
            </Text>
            <Text style={styles.observation}>
              {run.eqpanltrun_cimmediate_action || "-"}
            </Text>
          </View>
        </View>
        <View style={styles.columnObservation}>
          <View style={{ ...styles.containerObservation, borderBottomRightRadius: 4 }}>
            <Text style={styles.tableCell}>
              {intl.get("ciqReport.pdf.run_table.conclusion")}
            </Text>
            <Text style={styles.observation}>{run.eqpanltrun_cconclusion || "-"}</Text>
          </View>
        </View>
      </View>
    </View>
  )
}

function RcmpRunLaunchValue({ level, unitOfMeasure }) {
  if (!level?.eqpanltlaunch_nvalue && level?.eqpanltlaunch_nvalue !== 0) {
    return "-"
  }

  return `${level.eqpanltlaunch_nvalue}${unitOfMeasure}`
}

function RcmpLaunchWestgardRules({ rules }) {
  if (!rules?.length) {
    return <View style={styles.westgardRulesContainer}></View>
  }

  const pillStyles = {
    r: {
      backgroundColor: "#FF3541",
      color: "#FFFFFF",
    },
    a: {
      backgroundColor: "#FFAE00",
      color: colors.gray[8],
    },
  }

  return (
    <View style={styles.westgardRulesContainer}>
      {rules.map((rule) => {
        const eactionStyles = rule?.eqpanltlnchwgr_eaction?.includes("R")
          ? pillStyles.r
          : pillStyles.a

        return (
          <View
            style={{
              ...styles.westgardRulePill,
              backgroundColor: eactionStyles?.backgroundColor,
            }}
            key={`ciq-report-westgard-rule-${rule?.eqpanltlnchwgr_nid}`}
          >
            <Text
              style={{
                ...styles.westgardRulePillText,
                color: eactionStyles?.color || "#fff",
              }}
            >
              {rule?.eqpanltlnchwgr_wgrdr_cname}
            </Text>
          </View>
        )
      })}
    </View>
  )
}
